/*!
 * Copyright (C) 2017-2024, Peppermill Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are not permitted.
 *//*
 *	2017-04-19
 *		- Added code for award tickers.
 *		- Hashes now reset on page load if set to display a menu. are not permitted.
 *
 *	2017-07-13
 *		- Removed spanish from the list of languages for Google Translate.
 *
 *	2018-02-13
 *		- Added code to handle pointer-following-text-shadow in footer.
 *
 *	2018-11-27
 *		- Added DineTime overlay code.
 *
 *	2024-05-14 (jhoward)
 *		- Refactor DineTime widget code from lazy.js to DineTimeWidget.ts.
 *
 *	2024-07-17 (jhoward)
 *		- Add window.initTouchPageLinks() to lazy.js.
 */
(function () {
	
	var $artwork	=	$('.artwork'),
		$header		=	$('#header'),
		$footer		=	$('#footer'),
		$container	=	$('#container'),
		$pageLinks	=	$container.find('.body-container').filter('.page-links').find('.item');
	
	//MENU LINKS
	var menuLinkHistoryUsed	=	false;
	
	function loadMenuPDFFromProxy(menuID) {
		
		if (typeof menuID !== 'string')	menuID	=	$('.iframe-wrapper').find('iframe').data('menu-id');
		
		var win	=	window.open('/library/api/google-drive-pdfs.php?ACTION=VIEW_PDF&FILE_ID=' + encodeURIComponent(menuID));
		
		if (typeof win === 'undefined' || !win) {
			
			window.location			=	'/library/api/google-drive-pdfs.php?ACTION=VIEW_PDF&FILE_ID=' + encodeURIComponent(menuID);
			
		} else {
			
			if ($('.iframe-wrapper').find('.close').length) {
				
				$('.iframe-wrapper')
					.find('.close')
						.trigger('click');
				
			}/* else {
				
				window.location.hash	=	'reset';
				
			}*/
			
			win.focus();
			
		}
		
	}
	
	$(function () {

		ajaxLinkRegisterCallback(
			'MENU-VIEW-PDF',
			loadMenuPDFFromProxy
		);
		
	});
	
	//reset the hash on load if hash set to show a menu
	if (window.location.hash.replace('#', '').substr(0, 5) === 'menu-')	window.location.hash	=	'';
	
	$(window)
		.on('hashchange.menus', function (event) {
			
			var theHash	=	window.location.hash.replace('#', '');
			
			$('.iframe-wrapper')
				.find('.close')
					.trigger('click', [true]);
			
			if (theHash.substr(0, 5) === 'menu-') {
				
				//make sure there is a matching .menu-link in the DOM
				var menuID		=	theHash.substr(5),
					$btnMatch	=	$('.menu-link').filter('[data-menu-id=' + menuID + ']');
				
				if ($btnMatch.length) {
					
					//match found
					
					event.preventDefault();
					
					if ($('html').hasClass('on-corporate') || !Modernizr.touchevents) {
						
						loadMenuPDFFromProxy($btnMatch.data('menu-id'));
						
					} else {
						
						var $btn			=	($btnMatch.closest('li').length)
													?	$btnMatch.closest('li')
													:	$btnMatch,
							footerHeight	=	0,
							//footerHeight	=	($footer.find('.above-the-fold').hasClass('static'))	?	0	:	$(window).height() - $footer.find('.above-the-fold').offset().top,
							$wrapperEle		=	$('<div class="iframe-wrapper" />')
													.css({
														top			:	$header.height(),
														bottom		:	footerHeight,
														transform	:	'translateX(' + $btn.offset().left + 'px) translateY(' + ($btn.offset().top - $(window).scrollTop() - $header.height()) + 'px) scale(' + ($btn.outerWidth() / $(window).width()) + ', ' + ($btn.outerHeight() / ($(window).height() - $header.height() - footerHeight)) + ')'
													})
													.append(
														$('<iframe data-menu-id="' + $btnMatch.data('menu-id') + '" frameborder="0" src="https://drive.google.com/file/d/' + $btnMatch.data('menu-id') + '/preview" />')
															.on('load', function () {
																
																$(this)
																	.closest('.iframe-wrapper')
																		.addClass('loaded');
																
																clearTimeout($(this).data('loadTimer'));
																
															})
															.data('loadTimer', setTimeout(function () {
																
																//ask to use new proxy
																showOverlayDialog({
																	confirmAccept	:	'DOWNLOAD PDF',
																	confirmDeny		:	'KEEP WAITING',
																	confirmTitle	:	'Problems Loading Menu?',
																	confirmBody		:	'If you are still waiting for the menu to load, you can load the PDF directly by clicking "DOWNLOAD PDF" below.',
																	callback		:	'MENU-VIEW-PDF'
																});
																
															}, 10000))
													)
													.append(
														$('<a class="close" href="#" />').on('click', function (event, hashInitiated) {
															
															if (typeof hashInitiated !== 'boolean')	hashInitiated	=	false;
															
															event.preventDefault();
															
															clearTimeout($wrapperEle.find('iframe').data('loadTimer'));
															
															if (hashInitiated === true) {
																
																setTimeout(function () {
																	
																	$('.iframe-wrapper')
																		.remove();
																	
																	$('html')
																		.removeClass('scrollbar-hide');
																	
																	$('body')
																		.height('');
																	
																}, 250);
																
																$('html').removeClass('iframe-wrapper-show');
																
															} else {
																
																if (menuLinkHistoryUsed) {
																	
																	window.history.go(-1);
																	
																	menuLinkHistoryUsed	=	false;
																	
																} else {
																	
																	window.location.hash	=	'reset';
																	
																}
																
															}
															
														})
															.append('<svg width="24" height="24" viewBox="0 0 24 24" class="ic_close_24px" y="72"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>')
													).append(
														'<div class="loader"><svg xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" enable-background="new 16 15.5 34 65" xml:space="preserve" class="peppermill-loader" height="65px" width="34px" version="1.1" y="0px" x="0px" xmlns:cc="http://creativecommons.org/ns#" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="16 15.5 34 65" xmlns:dc="http://purl.org/dc/elements/1.1/"><path class="body" d="m37.135 69.196c0-1.088-0.62-2.023-1.518-2.503-6.236-16.312-2.125-25.311-1.617-26.314 0.886-0.854 1.29-1.748 1.201-2.657-0.041-0.423-0.188-0.78-0.369-1.083 0.502-0.367 0.832-0.955 0.832-1.622v-0.297c0-0.455-0.158-0.87-0.414-1.208 0.256-0.337 0.414-0.753 0.414-1.208v-0.296c0-0.504-0.193-0.96-0.5-1.313 0.705-1.138 1.078-2.404 1.078-3.703 0-4.375-4.179-7.936-9.313-7.936-5.136 0-9.314 3.561-9.314 7.936 0 1.299 0.373 2.565 1.079 3.702-0.307 0.354-0.5 0.81-0.5 1.314v0.296c0 0.455 0.157 0.871 0.413 1.208-0.256 0.338-0.413 0.753-0.413 1.208v0.297c0 0.667 0.33 1.255 0.832 1.622-0.181 0.303-0.329 0.66-0.37 1.083-0.088 0.909 0.316 1.803 1.202 2.657 0.507 1.003 4.618 10.002-1.617 26.314-0.899 0.479-1.519 1.415-1.519 2.503 0 0.445 0.112 0.861 0.295 1.237h-0.295v9.726h20.413v-9.726h-0.295c0.182-0.375 0.295-0.791 0.295-1.237m-16.928-33.776c-0.218 0-0.403-0.185-0.403-0.403v-0.297c0-0.218 0.185-0.403 0.403-0.403h13.443c0.22 0 0.404 0.185 0.404 0.403v0.297c0 0.218-0.185 0.403-0.404 0.403h-13.443zm-0.403-3.116v-0.296c0-0.198 0.154-0.362 0.346-0.392h13.558c0.19 0.03 0.346 0.194 0.346 0.392v0.296c0 0.218-0.185 0.403-0.404 0.403h-13.443c-0.218 0-0.403-0.186-0.403-0.403m7.125-11.638c4.248 0 7.703 2.838 7.703 6.326 0 1.053-0.321 2.085-0.931 3.007-0.018 0-0.033-0.005-0.052-0.005h-13.442c-0.017 0-0.033 0.005-0.051 0.005-0.61-0.922-0.931-1.954-0.931-3.007 0-3.488 3.456-6.326 7.704-6.326m-5.725 18.816l-0.061-0.106-0.09-0.083c-0.388-0.358-0.841-0.893-0.795-1.408 0.034-0.382 0.33-0.693 0.517-0.855h12.307c0.186 0.16 0.479 0.47 0.517 0.848 0.05 0.517-0.404 1.055-0.795 1.415l-0.089 0.083-0.062 0.106c-0.223 0.385-5.261 9.437 1.113 26.867h-13.676c6.374-17.43 1.337-26.482 1.114-26.867m-2.872 29.714c0-0.448 0.243-0.839 0.601-1.056h15.991c0.358 0.217 0.601 0.607 0.601 1.056 0 0.683-0.555 1.237-1.236 1.237h-14.719c-0.682 0.001-1.238-0.554-1.238-1.237m17.192 9.353h-17.192v-6.505h17.192v6.505z" clip-path="url(#a)"></path><path class="body-top" d="m27.451 20.347c-1.302 0-2.361-1.059-2.361-2.361 0-1.301 1.059-2.36 2.361-2.36s2.36 1.059 2.36 2.36c0 1.303-1.058 2.361-2.36 2.361" clip-path="url(#a)"></path><path class="handle" d="m48.404 17.031h-19.398v1.732h14.979l-1.133 4.363s1.341-0.366 3.508-0.366c2.168 0 3.509 0.366 3.509 0.366l-1.465-6.095z" clip-path="url(#a)"></path><circle class="circle circle-1" cx="20" cy="85" r="1"></circle><circle class="circle circle-2" cx="27" cy="84" r="1"></circle><circle class="circle circle-3" cx="24" cy="89" r="1"></circle><circle class="circle circle-4" cx="35" cy="83" r="1"></circle><circle class="circle circle-5" cx="31" cy="86" r="1"></circle></svg></div>'
													);
						
						$('body')
							.append($wrapperEle);
						
						setTimeout(function () {
							
							$('body')
								.height($container.height() + $footer.height());
							
							$('html')
								.addClass('iframe-wrapper-show scrollbar-hide');
							
							$wrapperEle
								.css({
									transform	:	''
								});
							
						}, 50);
						
					}
					
				}
				
			}
			
		})
		.trigger('hashchange.menus');
	
	$('.menu-link')
		.on('click', function (event) {
			
			//first off check if the user can access google drive, if not just download the PDF
			if ($('html').hasClass('on-corporate') || !Modernizr.touchevents) {
				
				event.preventDefault();
				
				loadMenuPDFFromProxy($(this).data('menu-id'));
				
			} else if (!$('html').hasClass('old-ie')) {
				
				event.preventDefault();
				
				window.location.hash	=	'menu-' + encodeURIComponent($(this).data('menu-id'));
				menuLinkHistoryUsed		=	true;
				
			}
			
		});
	
	$(document).on('keydown', function (event) {
		
		if (event.which === 27) {
			
			$('#container').children('.iframe-wrapper, .gallery-wrapper').children('.close').trigger('click');
			
		}
		
	});
	
	
	
	
	
	
	
	
	
		
	//floogplan code
	$('#container')
		.find('.right-side-content')
			.find('.floorplan')
				.data('active', false)
				.on('click', function (event) {
					
					event.preventDefault();
					
					var $link	=	$(this);
					
					if ($link.data('active'))	return;
					
					$link
						.data('active', true);
					
					if ($link.closest('.viewport').children('.floorplan-viewport').length) {
						
						//close
						$link
							.closest('.viewport')
								.children('.floorplan-viewport')
									.removeClass('show');
						
						setTimeout(function () {
							
							$link
								.closest('.viewport')
									.children('.floorplan-viewport')
										.remove();
							
							$link
								.data('active', false);
							
						}, 350);
						
					} else {
						
						//open
						var $floorplanViewport	=	$('<div class="floorplan-viewport"><a class="close" data-tooltip="Close Floor Plan" href="#"><svg width="24" height="24" viewBox="0 0 24 24" class="ic_close_24px" y="72"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg></a><div class="floorplan" style="background-image:url(\'' + $link.attr('href') + '\');"></div><div class="shadow"></div></div>'),
							artworkPosition		=	$artwork.position(),
							linkPosition		=	$link.position(),
							artworkSize			=	{
								width	:	$artwork.outerWidth(false),
								height	:	$artwork.outerHeight(false)
							};
						
						$floorplanViewport
							.css({
								top			:	artworkPosition.top,
								left		:	artworkPosition.left,
								width		:	artworkSize.width,
								height		:	artworkSize.height,
								transform	:	'translateX(' + (linkPosition.left - artworkPosition.left + parseInt($link.css('marginLeft'), 10)) + 'px) translateY(' + (linkPosition.top - artworkPosition.top) + 'px) scale(' + ($link.outerWidth(false) / artworkSize.width * 1.1) + ', ' + ($link.outerHeight(false) / artworkSize.height * 1.1) + ')'
							})
							.find('.close')
								.on('click', function (event) {
									
									event.preventDefault();
									
									$link
										.trigger('click');
									
								});
						
						$link
							.closest('.viewport')
								.append($floorplanViewport);
						
						setTimeout(function () {
							
							$floorplanViewport
								.addClass('show')
								.css({
									transform	:	''
								});
							
							setTimeout(function () {
								
								$link
									.data('active', false);
								
							}, 350);
							
						}, 50);
						
					}
					
				});
	
	
	
	
	
	
	
	
	
	if ($('#google_translate_element').length) {
		
		window.googleTranslateElementInit	=	function () {
			
			new google.translate.TranslateElement({pageLanguage: 'en', includedLanguages: 'en,tl,zh-CN,zh-TW', layout: google.translate.TranslateElement.InlineLayout.SIMPLE, autoDisplay: false, gaTrack: true, gaId: 'UA-31151-1'}, 'google_translate_element');
			
		}
		
		$.getScript('https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');
		
	}
	
	
	
	
	
	
	
	
	
	
	
	/*
	//footer text-shadow code
	if (!Modernizr.touchevents) {
		
		var $shadowTextEle			=	$footer.find('.image-area').find('.text'),
			shadowInitialCSS		=	$shadowTextEle.css('text-shadow'),
			shadowCSSString			=	shadowInitialCSS.replace(/[0-9\.]{1,}px/, '{X}').replace(/[0-9\.]{1,}px/, '{Y}').replace(/[0-9\.]{1,}px/, '{Z}'),
			shadowInitialData		=	shadowInitialCSS.match(/[0-9\.]{1,}px/g),
			shadowAreaWidth			=	$footer.find('.image-area').width(),
			shadowAreaHeight		=	$footer.find('.image-area').height(),
			shadowAreaOffsetTop		=	$footer.find('.image-area').offset().top,
			shadowAreaMaxChangeX	=	shadowAreaWidth / -8,
			shadowAreaMaxChangeY	=	shadowAreaHeight / -8,
			shadowAreaMaxChangeZ	=	15,
			shadowNeedToRender		=	false,
			shadowLastPointerX		=	0,
			shadowLastPointerY		=	0;
		
		function renderFooterShadow() {
			
			if (shadowNeedToRender) {

				var tmpX	=	((shadowLastPointerX - (shadowAreaWidth / 2)) / shadowAreaWidth),
					tmpY	=	((shadowLastPointerY - shadowAreaOffsetTop - (shadowAreaHeight / 2)) / shadowAreaHeight),
					newX	=	shadowInitialData[0] + tmpX * shadowAreaMaxChangeX,
					newY	=	shadowInitialData[1] + tmpY * shadowAreaMaxChangeY,
					newZ	=	shadowInitialData[2] + Math.sqrt(tmpX * tmpX + tmpY * tmpY) * 2 * shadowAreaMaxChangeZ;
				
				//console.log(newX, newY, newZ, Math.sqrt(tmpX * tmpX + tmpY * tmpY));
				
				$shadowTextEle
					.css({
						textShadow	:	shadowCSSString.replace('{X}', newX + 'px').replace('{Y}', newY + 'px').replace('{Z}', newZ + 'px')
					});
				
			}
			
			requestAnimationFrame(renderFooterShadow);
			
		}
		
		if (shadowInitialData) {

			shadowInitialData[0]	=	parseInt(shadowInitialData[0], 10);
			shadowInitialData[1]	=	parseInt(shadowInitialData[1], 10);
			shadowInitialData[2]	=	parseInt(shadowInitialData[2], 10);
			
			$footer
				.find('.image-area')
					.on('mouseenter', function () {
						
						shadowNeedToRender	=	true;
						
					})
					.on('mouseleave', function () {
						
						shadowNeedToRender	=	false;
						
					})
					.on('mousemove', function (event) {
						
						shadowLastPointerX	=	event.pageX;
						shadowLastPointerY	=	event.pageY;
						
					});
			
			requestAnimationFrame(renderFooterShadow);
			
		}
		
	}
	*/
	
	
	
	
	
	
	
	
	
	
	
	
	//touch effects code
	if (Modernizr.touchevents) {
		
		var touchEffectEvent	=	{},
			touchEffectTimer	=	null;
		
		function showTouchEffect(ele, event) {
			
			var $ele				=	$(ele),
				$newEffect			=	$('<span class="touch-effect"></span>')
											.css({
												top				:	((event.touches[0].clientY - $ele.offset().top + $(window).scrollTop()) / $ele.outerHeight() * 100) + '%',
												left			:	((event.touches[0].clientX - $ele.offset().left + $(window).scrollLeft()) / $ele.outerWidth() * 100) + '%'
											});

			$ele
				.append($newEffect);
			
			setTimeout(function () {
				
				$newEffect
					.parent()
					.addClass('show-touch-effect');
				
				setTimeout(function () {
					
					$newEffect
						.addClass('hide');
					
					setTimeout(function () {
						
						$newEffect
							.parent()
								.removeClass('show-touch-effect')
							.end()
							.remove();
						
					}, 250);
					
				}, 300);
				
			}, 50);
			
		}
		
		function renderTouchEffects() {
			
			if (typeof touchEffectEvent.target !== 'undefined') {
				
				var ele		=	$(touchEffectEvent.target).closest('a')[0],
					orgEvnt	=	touchEffectEvent;
				
				touchEffectTimer	=	setTimeout(function () {
					
					showTouchEffect(ele, orgEvnt);
					
				}, 50);
				
				touchEffectEvent	=	{};
				
			}
			
			requestAnimationFrame(renderTouchEffects);
			
		}
		
		$('a')
			.each(function () {
				
				this
					.addEventListener('touchstart', function (event) {
						
						if (event.touches.length === 1) {
							
							touchEffectEvent	=	event;
							
						}
						
					}, { passive : true });
				
				this
					.addEventListener('touchmove', function (event) {
						
						touchEffectEvent	=	{};
						
						clearTimeout(touchEffectTimer);
						
					}, { passive : true });
				
			});
		
		window
			.addEventListener('scroll', function () {
				
				clearTimeout(touchEffectTimer);
				
			}, { passive : true });
		
		$(function () {
			
			requestAnimationFrame(renderTouchEffects);
			
		});
		
	}
	
	
	
	
	
	
	
	
	
	
	//Outlet Hours API
	var requestOutletHours	=	!!$pageLinks.filter(function () {
			
			return $(this).closest('.page-links').not('.homepage').not('.related-events').length;
			
		}).length;
	
	function parseOutletHourAPIResponse(response, cacheOutletHoursResponse) {
		
		if (typeof cacheOutletHoursResponse === 'undefined')	var cacheOutletHoursResponse	=	true;
		
		if (response.STATUS === 'SUCCESS') {
			
			//add "Open Now" or "Open Later" to the .right-side-content element -- DISABLED
			/*var currentPageID	=	$('body').data('i'),
				pageFound		=	false;
			
			if ($.inArray($('body').data('i'), response.OPEN_NOW.PAGES) > -1) {
				
				$('h1')
					.append('<span class="open-now">Open Now</span>');
				
			} else if ($.inArray($('body').data('i'), response.OPEN_LATER.PAGES) > -1) {
				
				$('h1')
					.append('<span class="open-later">Opens Later</span>');
				
			}*/
			
			//add to .page-link .item elements
			$.each($pageLinks, function (i) {
				
				if ($.inArray($pageLinks.eq(i).data('page-id'), response.OPEN_NOW.PAGES) > -1) {
					
					$pageLinks
						.eq(i)
							.find('h2')
								.append('<span class="open-now">Open Now</span>');
					
				} else if ($.inArray($pageLinks.eq(i).data('page-id'), response.OPEN_LATER.PAGES) > -1) {
					
					$pageLinks
						.eq(i)
							.find('h2')
								.append('<span class="open-later">Opens Later</span>');
					
				}
				
			});
			
		}
		
		if (Modernizr.json && Modernizr.localstorage && cacheOutletHoursResponse) {
			
			var cacheString	=	JSON.stringify({
				endOfLife	:	new Date().getTime() + 300000,
				response	:	response
			});
			
			try {
				
				localStorage.setItem('outletHoursAPI', cacheString);
				
			} catch (e) {}
			
		}
		
	}
	
	//check for cached data that's current enough to display
	if (requestOutletHours && Modernizr.json && Modernizr.localstorage && typeof localStorage.getItem('outletHoursAPI') === 'string') {
		
		var outletHoursCache	=	$.parseJSON(localStorage.getItem('outletHoursAPI'));
		
		if (parseInt(outletHoursCache.endOfLife, 10) > new Date().getTime()) {
			
			requestOutletHours	=	false;
			
			parseOutletHourAPIResponse(outletHoursCache.response, false);
			
		} else {
			
			//remove from cache since the data is old
			localStorage.removeItem('outletHoursAPI');
			
		}
		
	}
	
	if (requestOutletHours) {
		
		$.ajax({
			url			:	'/library/api/outlet-hours.php',
			type		:	'post',
			dataType	:	'json',
			success		:	parseOutletHourAPIResponse,
			error		:	function (jqXHR, textStatus, errorThrown) {
				
				//log this error
				var extraText	=	(typeof errorThrown === 'string')
										?	' -- ' + errorThrown
										:	'';
				pepTracking.event('JS Error', 'Outlet Hours AJAX', textStatus + extraText, 0, true);
				
				$.ajax({
					url			:	'/library/api/capture-js-error.php',
					dataType	:	'json',
					type		:	'post',
					data		:	{
						je_message	:	'Outlet Hours AJAX Failure',
						je_source	:	'https://www.peppermillreno.com/library/js/main.min.js',
						je_lineno	:	0,
						je_colno	:	0,
						je_url		:	window.location.href,
						je_stack	:	"Status: " + jqXHR.status + "\n\nResponse Text:\n" + jqXHR.responseText
					}
				});
				
			}
		});
		
	}










  //DINETIME OVERLAY CODE
  require('./helpers/DineTimeWidget');




  window.initTouchPageLinks	=	function ($bodyContainers) {

    if (Modernizr.touchevents) {

      if ('object' !== typeof $bodyContainers) {

        var $bodyContainers	=	$('.body-container').filter('.page-links');

      }

      $bodyContainers
        .children('.viewport')
        .off('scroll.hscroll')
        .one('scroll.hscroll', function () {

          $(this)
            .closest('.page-links')
            .addClass('scrolled');

        })
        .off('click.hscroll')
        .on('click.hscroll', function (event) {

          if (event.target === this) {

            $(this)
              .off('click.hscroll');

            if (!$(this).closest('.page-links').hasClass('scrolled') && 1 < $(this).find('.item').not('.hide').length) {

              $(this)
                .animate({ scrollLeft : $(this).find('.item').not('.hide').eq(0).outerWidth() + parseInt($(this).css('padding-left'), 10) }, 250, 'easeInOutCubic')
                .closest('.page-links')
                .addClass('scrolled');

            }

          }

        });

    }

  };

  initTouchPageLinks();
})();